import { h, Component } from 'preact';
import { gateways } from 'store/ticketingPublic';
import { getCopy } from 'utils/copy';
import { joinClasses } from 'utils/utils';
import AuthnetPaymentGateway from 'components/shared/theaters/ticketing/gateways/authnetPaymentGateway/authnetPaymentGateway';
import VantivPaymentGateway from 'components/shared/theaters/ticketing/gateways/vantivPaymentGateway/vantivPaymentGateway';
import PxPayPaymentGateway from 'components/shared/theaters/ticketing/gateways/pxpayPaymentGateway/pxpayPaymentGateway';
import Verifone2PaymentGateway from 'components/shared/theaters/ticketing/gateways/verifone2PaymentGateway/verifone2PaymentGateway';
import BraintreePaymentGateway from 'components/shared/theaters/ticketing/gateways/braintreePaymentGateway/braintreePaymentGateway';
import MastercardPaymentGateway from 'components/shared/theaters/ticketing/gateways/mastercardPaymentGateway/mastercardPaymentGateway';
import s from 'components/shared/theaters/ticketing/gateways/paymentGateway.sss';

/**
 * The PaymentGateway is the link between the payment frontend process and the payment provider.
 */
export default class PaymentGateway extends Component {

	render(props) {
		switch (props.ticketing.paymentGateway) {
			case gateways.AUTHNET:
				return <AuthnetPaymentGateway {...props} />;
			case gateways.VANTIV:
				return <VantivPaymentGateway {...props} />;
			case gateways.PXPAY:
				return <PxPayPaymentGateway {...props} />;
			case gateways.VERIFONE2:
				return <Verifone2PaymentGateway {...props} />;
			case gateways.BRAINTREE:
				return <BraintreePaymentGateway {...props} />;
			case gateways.MASTERCARD:
				return <MastercardPaymentGateway {...props} />;
			default:
				// We should never get here, an error will be generated before
				return <p class={joinClasses(this.props.class, s.noGatewayCompMsg)}>{getCopy('NO_PAYMENT_GATEWAY_FOUND')}</p>;
		}
	}

}
